import { User } from "@/services";
import { defineStore } from "pinia";

type State = {
  user: User | undefined;
  token: string | undefined | null;
};

export const useAuthStore = defineStore("auth", {
  state(): State {
    return {
      user: undefined,
      token: localStorage.getItem("token"),
    };
  },
  actions: {
    setUser(user: User) {
      this.user = user;
    },
    setToken(token: string) {
      this.token = token;
      localStorage.setItem("token", token);
    },
    removeUser() {
      this.user = undefined;
    },
    removeToken() {
      this.token = null;
      localStorage.removeItem("token");
    },
    removeSession() {
      this.removeUser();
      this.removeToken();
    },
  },
  getters: {
    getUser(state): Readonly<User> {
      return state!.user!;
    },
    hasUser(state): Readonly<boolean> {
      return !!state.user;
    },
    hasToken(state): Readonly<boolean> {
      return !!state.token;
    },
    getToken(state): Readonly<string> | undefined | null {
      return state.token;
    },
    getRole(state): Readonly<"ADMIN" | "USER" | "MANAGER"> | undefined {
      if (!state.user) {
        return undefined;
      }
      return state?.user?.role;
    },
    isAdmin(state): Readonly<boolean> {
      return state.user?.role === "ADMIN";
    },
    isManager(state): Readonly<boolean> {
      return state.user?.role === "MANAGER";
    },
    isUser(state): Readonly<boolean> {
      return state.user?.role === "USER";
    },
  },
});
